import { render, staticRenderFns } from "./UserCardAdditionalInfos.vue?vue&type=template&id=110e080b&scoped=true&"
import script from "./UserCardAdditionalInfos.vue?vue&type=script&lang=ts&"
export * from "./UserCardAdditionalInfos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110e080b",
  null
  
)

export default component.exports